<template>
    <div class="download-container">
      <div v-if="loading" class="status-message">
        <div class="spinner"></div>
        <p>Downloading app...</p>
      </div>
      
      <div v-else-if="error" class="error-message">
        <p>{{ error }}</p>
        <button @click="retryDownload" class="retry-button">Retry Download</button>
        <button @click="back" class="back-button">Go Back</button>
      </div>
      
      <div v-else class="manual-download">
        <p>If download doesn't start automatically:</p>
        <button @click="downloadApp" class="download-button">Download Manually</button>
      </div>
    </div>
  </template>
  
  <script>
  import api from '@/api'
  import router from '@/router/index'
  
  export default {
    name: 'home',
    data() {
      return {
        perms: [],
        from: null,
        loading: true,
        error: null,
        downloadAttempts: 0,
        maxAttempts: 3
      }
    },
    async created() {
      try {
        this.perms = api.getPerms();
        
        if (!this.perms || !Array.isArray(this.perms)) {
          throw new Error('Unable to verify permissions');
        }
        
        if (this.perms.includes('87')) {
          await this.downloadApp();
        } else {
          this.error = 'You do not have permission to download this app';
          this.loading = false;
          setTimeout(() => this.back(), 3000);
        }
      } catch (err) {
        this.error = 'Failed to initialize download';
        this.loading = false;
        console.error('Initialization error:', err);
      }
    },
    methods: {
        async downloadApp() {
            if (this.downloadAttempts >= this.maxAttempts) {
            this.error = 'Maximum download attempts reached. Please try again later.';
            this.loading = false;
            return;
            }
            
            this.downloadAttempts++;
            this.loading = true;
            this.error = null;
            
            try {
                const response = await api.getMobileDownload(
                    {
                        type: "search",
                        data: {
                            pageid: this.id
                        }
                    },
                    "candidate"
                );
                
                if (!response || !response.data) {
                    throw new Error('No download data received from server');
                }
                
                // Check if response is an error blob
                if (response.data.type === 'application/json') {
                    const text = await response.data.text();
                    throw new Error(text || 'Download failed');
                }
                
                // Create and trigger download
                const blob = new Blob([response.data], { type: 'application/vnd.android.package-archive' });
                const fileURL = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = fileURL;
                link.setAttribute('download', 'app-debug.apk');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                
                // Cleanup
                setTimeout(() => {
                    URL.revokeObjectURL(fileURL);
                }, 100);
                
                this.loading = false;
                
                // Optional: redirect after successful download
                setTimeout(() => this.back(), 2000);
                
            } catch (err) {
                console.error('Download error:', err);
                this.error = err.message || 'Failed to download app. Please try again.';
                this.loading = false;
            }
        },
        
        retryDownload() {
            this.downloadApp();
        },
        
        back() {
            const fromPath = this.from && this.from.path ? this.from.path : null;
            const targetPath = fromPath === "/downloadcandidateapp" || !fromPath
            router.replace(targetPath);
        }
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        vm.from = from;
      });
    }
  }
  </script>
  
  <style scoped>
  .download-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: calc(100vh - 60px);
    padding: 20px;
  }
  
  .status-message,
  .error-message,
  .manual-download {
    text-align: center;
    max-width: 400px;
  }
  
  .spinner {
    width: 50px;
    height: 50px;
    margin: 0 auto 20px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  .error-message {
    color: #e74c3c;
  }
  
  .error-message p {
    margin-bottom: 20px;
    font-weight: 500;
  }
  
  button {
    padding: 12px 24px;
    margin: 8px;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .download-button,
  .retry-button {
    background-color: #3498db;
    color: white;
  }
  
  .download-button:hover,
  .retry-button:hover {
    background-color: #2980b9;
  }
  
  .back-button {
    background-color: #95a5a6;
    color: white;
  }
  
  .back-button:hover {
    background-color: #7f8c8d;
  }
  
  button:disabled {
    background-color: #bdc3c7;
    cursor: not-allowed;
  }
  
  .frame {
    margin-left: calc(50% - 291.75pt);
    width: 583.5pt;
    height: calc(100vh - 60px);
    border: none;
  }
  </style>


// WEBPACK FOOTER //
// src/components/DownloadCandidateApp.vue